import { FCC } from "@/types/common";
import { TCompanyForm } from "@/features/company/types/CompanyForm";
import { Grid } from "@mui/material";
import { CompanyLogo } from "@/features/company/components/company-detail/CompanyLogo";
import { CompanyInfoItem } from "@/features/company/components/company-detail/CompanyInfoItem";
import { InnerBox } from "@/components/elements/InnerBox";
import { CompanyFormTitle } from "@/features/company/components/company-info/CompanyFormTitle";
import { convertNumberToCommas } from "@/utils/input";

type TCompanyBasicInfoProps = {
  defaultValues: Partial<TCompanyForm>;
};

export const CompanyBasicInfo: FCC<TCompanyBasicInfoProps> = ({ defaultValues }) => {
  const capital = defaultValues?.capital ? convertNumberToCommas(defaultValues?.capital) : null;
  return (
    <InnerBox title={<CompanyFormTitle text="企業基本情報" />} showDivider={false}>
      <Grid
        container
        sx={{
          marginTop: "8px",
        }}
      >
        <Grid item xs={12}>
          <Grid container spacing={1}>
            <Grid item xs={1}>
              <CompanyLogo logo={defaultValues?.companyLogo} />
            </Grid>
            <Grid item xs={11}>
              <CompanyInfoItem label="企業管理番号" value={defaultValues?.managementNumber} />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Grid container spacing={3}>
            <Grid item xs={6}>
              <CompanyInfoItem label="企業名" value={defaultValues?.companyName} required />
            </Grid>
            <Grid item xs={6}>
              <CompanyInfoItem label="企業名かな" value={defaultValues?.companyKanaName} />
            </Grid>
            <Grid item xs={4}>
              <CompanyInfoItem label="設立年" value={defaultValues?.establishmentYear} suffix="年" />
            </Grid>
            <Grid item xs={4}>
              <CompanyInfoItem label="資本金" value={capital} endIcon="円" />
            </Grid>
            <Grid item xs={4}>
              <CompanyInfoItem label="従業員数" value={defaultValues?.numberOfEmployees} />
            </Grid>
            <Grid item xs={6}>
              <CompanyInfoItem label="代表者名" value={defaultValues?.representativeName} />
            </Grid>
            <Grid item xs={6}>
              <CompanyInfoItem label="代表者役職" value={defaultValues?.representativePosition} />
            </Grid>
            <Grid item xs={6}>
              <CompanyInfoItem label="電話番号" value={defaultValues?.telNumber} type="phone" />
            </Grid>
            <Grid item xs={6}>
              <CompanyInfoItem label="FAX番号" value={defaultValues?.faxNumber} type="phone" />
            </Grid>
            <Grid item xs={6}>
              <CompanyInfoItem label="メールアドレス" value={defaultValues?.contactEmail} />
            </Grid>
            <Grid item xs={6}>
              <CompanyInfoItem label="ウェブサイトURL" value={defaultValues?.websiteUrl} type="link" />
            </Grid>
            <Grid item xs={4}>
              <CompanyInfoItem label="郵便番号" value={defaultValues?.zipCode} type="zipcode" />
            </Grid>
            <Grid item xs={4}>
              <CompanyInfoItem label="都道府県" value={defaultValues?.prefecture} />
            </Grid>
            <Grid item xs={4}>
              <CompanyInfoItem label="市区町村" value={defaultValues?.city} />
            </Grid>
            <Grid item xs={12}>
              <CompanyInfoItem label="町名丁目番地号等" value={defaultValues.address} isShowDivider={false} />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </InnerBox>
  );
};
